import axios, { AxiosResponse } from 'axios';
import { get } from 'js-cookie';

export const customPromptPresetOption: AiTextGenerationPresetOption = {
  value: 'custom-prompt',
  label: 'Custom prompt...',
  description: 'Use your own prompt for text generation.',
  availableWhen: 'always',
};

export type GenerateTextContext = {
  text?: string;
  conversationId?: string;
  context: {
    pageId: number;
    pageItemType: string;
    fieldName: string;
    relatedFields: Record<string, string>;
  };
} & ({ userInstructions: string; presetIdentifier?: string } | { userInstructions?: string; presetIdentifier: string });

export interface GenerateTextResponse {
  generatedText: string;
  conversationId: string;
}

export interface AiTextGenerationPresetOption {
  label: string;
  description: string;
  value: string;
  availableWhen: 'when-has-content' | 'always' | 'when-empty';
}

class WWSApiService {
  static async generateText(context: GenerateTextContext, abortSignal?: AbortSignal) {
    const host = process.env.REACT_APP_WWS_AUTH_API_ENDPOINT;

    const response = await axios.post<GenerateTextContext, AxiosResponse<GenerateTextResponse>>(
      `${host}/ai-text-generation/generate-text`,
      context,
      {
        headers: {
          token: get('xo-session-token') as string,
        },
        signal: abortSignal,
      }
    );

    return response.data;
  }

  static async getPresets() {
    const host = process.env.REACT_APP_WWS_AUTH_API_ENDPOINT;
    const response = await axios.get<AiTextGenerationPresetOption[]>(
      `${host}/ai-text-generation/instructions/presets`,
      {
        headers: {
          token: get('xo-session-token') as string,
        },
      }
    );
    return response.data;
  }
}

export default WWSApiService;
